import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function ComingSoon({ title, phase, description, testid }) {
  return (
    <div className="max-w-2xl mx-auto text-center py-24" data-testid={testid || "coming-soon"}>
      <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-blue-500/30 bg-blue-500/5">
        <Sparkles size={13} className="text-blue-400" />
        <span className="text-[11px] tracking-[0.22em] uppercase text-blue-300 font-medium">
          Phase {phase} · Coming soon
        </span>
      </div>
      <h1 className="font-display text-4xl mt-6 text-white">{title}</h1>
      <p className="mt-4 text-white/60 max-w-md mx-auto text-[15px] leading-relaxed">
        {description}
      </p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Link
          to="/admin/dashboard"
          className="inline-flex items-center gap-1.5 text-sm rounded-full border border-white/15 hover:border-white/30 px-4 py-2 text-white/80 hover:text-white transition-colors"
        >
          Back to Overview
        </Link>
        <Link
          to="/admin/dashboard/leads"
          className="inline-flex items-center gap-1.5 text-sm rounded-full bg-blue-500 hover:bg-blue-600 px-4 py-2 text-white transition-colors"
        >
          Open CRM
        </Link>
      </div>
    </div>
  );
}
